import { render, staticRenderFns } from "./Drivers.vue?vue&type=template&id=4c7fb2fe&"
import script from "./Drivers.vue?vue&type=script&lang=js&"
export * from "./Drivers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c7fb2fe')) {
      api.createRecord('4c7fb2fe', component.options)
    } else {
      api.reload('4c7fb2fe', component.options)
    }
    module.hot.accept("./Drivers.vue?vue&type=template&id=4c7fb2fe&", function () {
      api.rerender('4c7fb2fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Drivers.vue"
export default component.exports